'use client'
import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const ChangeArrowsIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	const height = React.useMemo(() => {
		return props?.height || 12
	}, [props])

	const width = React.useMemo(() => {
		return props?.width || 15
	}, [props])

	const viewBox = `0 0 ${width} ${height}`

	return (
		<svg
			className={props.className}
			viewBox={viewBox}
			height={height}
			width={width}
			onClick={props.onClick}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path d="M3.65 11.85C3.84 12.05 4.16 12.05 4.35 11.85L7.54 8.67C7.73 8.48 7.73 8.16 7.54 7.96C7.34 7.77 7.02 7.77 6.83 7.96L4 10.79L1.17 7.96C0.98 7.77 0.66 7.77 0.46 7.96C0.27 8.16 0.27 8.48 0.46 8.67L3.65 11.85ZM3.5 0.5L3.5 11.5H4.5L4.5 0.5H3.5Z" />
			<path d="M10.85 0.15C10.66 -0.05 10.34 -0.05 10.15 0.15L6.96 3.33C6.77 3.52 6.77 3.84 6.96 4.04C7.16 4.23 7.48 4.23 7.67 4.04L10.5 1.21L13.33 4.04C13.52 4.23 13.84 4.23 14.04 4.04C14.23 3.84 14.23 3.52 14.04 3.33L10.85 0.15ZM11 11.5L11 0.5L10 0.5L10 11.5L11 11.5Z" />
		</svg>
	)
}

export default ChangeArrowsIcon
